export default __webpack_public_path__ + "static/media/step3incomplete.da92fbd4.png";